import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { EditUserAchievementAdminSettingsFulfilledAction } from '../../domains/userAchievementsSettings/editUserAchievementAdminSettingsActions.types';
import type { UserAchievementsSettingsLoadAction } from '../../domains/userAchievementsSettings/loadUserAchievementsSettingsActions.types';

import type { UserAchievementsSettingsLifecycle } from './types';

export type UserAchievementsSettingsAction =
  | UserAchievementsSettingsLoadAction
  | EditUserAchievementAdminSettingsFulfilledAction;

const initialState: UserAchievementsSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const editUserAchievementAdminSettings = (
  state: UserAchievementsSettingsLifecycle,
  { adminSettingsType }: EditUserAchievementAdminSettingsFulfilledAction['payload']
): UserAchievementsSettingsLifecycle => {
  const currentFulfilledState = state.fulfilled;

  return {
    ...state,
    fulfilled: {
      ...currentFulfilledState,
      adminSettingsType,
    },
  };
};

const reducer: Reducer<UserAchievementsSettingsLifecycle, UserAchievementsSettingsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'USER_ACHIEVEMENTS_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'USER_ACHIEVEMENTS_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.userAchievementsSettings);
    case 'EDIT_USER_ACHIEVEMENT_ADMIN_SETTINGS.FULFILLED':
      return editUserAchievementAdminSettings(state, action.payload);
    case 'USER_ACHIEVEMENTS_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
